export const DATE_FORMAT = {
    DEFAULT_EU: 'DD.MM.YYYY',
    DEFAULT_US: 'MM/DD/YYYY',
    MIXED: 'DD/MM/YYYY',
};
